/*
 * Copyright (c) 2019
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Xaero Zero - xaerozero@icloud.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthProvider } from '../../../providers';
import { Router } from '@angular/router';
import { CrmAlertComponent } from '../../fields';
import { LogService } from 'src/app/services';

@Component({
  selector: 'page-forgot',
  templateUrl: 'forgot.page.html',
  styleUrls: ['forgot.page.scss']
})

export class ForgotPage implements OnInit, OnDestroy {
  @ViewChild('alert') alert: CrmAlertComponent;

  forgotForm: FormGroup;

  constructor(
    private fb: FormBuilder,
    private authProvider: AuthProvider,
    private router: Router,
    private logService : LogService
  ) {
    this.forgotForm = this.fb.group({
      USER_EMAIL: [null, Validators.compose([Validators.required, Validators.pattern('[^ @]*@[^ @]*')])],
    });
  }

  onSubmit(): void {
    this.alert.hide();

    if (this.forgotForm.valid) {

      this.authProvider.requestReset(this.forgotForm.value.USER_EMAIL)
        .subscribe(response => {

          if (response.success) {
            this.alert.showSuccess('Password reset link has been sent to your email');

            this.forgotForm.reset();

            setTimeout(() => {
              this.router.navigate(['/login']);
            }, 5000);
          } else {
            this.alert.show(response.error);
          }

        }, err => {
          this.logService.error(err);
        });
    }
  }

  ngOnDestroy(): void {

  }

  ngOnInit(): void {
  }

}
